// extracted by mini-css-extract-plugin
export default {"Toaster":"Toaster_Toaster__En69G"};